/* eslint-disable */
/* tslint:disable */

/** submitApplication
 * method: post
 * summary: Submit a Hublo Pool application
 */

import type { SubmitApplicationResponseDto } from './../api-types'

export const path = `/bff-worker/pool/application/submit`
export const fullPath = `${process.env.BFF_WORKER_BASE_URL || 'http://bff-worker.svc.cluster.local'}/bff-worker/pool/application/submit`

export type SubmitApplicationSuccess = SubmitApplicationResponseDto
export type SubmitApplicationError = never
